module.exports = __webpack_public_path__ + "static/media/关键词提取).e5de97c5.png";